import React from 'react';

function ModulePageHeader({ title, subtitle, eyebrow, actions }) {
  return (
    <div
      className={[
        'platform-page-header',
        actions ? 'platform-page-header--with-actions' : '',
      ].filter(Boolean).join(' ')}
    >
      <div className="platform-page-header__intro">
        {eyebrow ? <span className="platform-page-eyebrow">{eyebrow}</span> : null}
        {title ? <h1 className="platform-page-title">{title}</h1> : null}
        {subtitle ? <p className="platform-page-subtitle">{subtitle}</p> : null}
      </div>
      {actions ? (
        <div className="platform-page-header__actions">{actions}</div>
      ) : null}
    </div>
  );
}

export default ModulePageHeader;
